import './OnboardStart.scss'

import React, {Component} from 'react'
import { Button } from 'react-bootstrap'

import { push } from 'react-router-redux'

const OnboardStart = ({dispatch}) => {

  function handleClick() {
    dispatch(push({pathname: '/onboard/price'}))
  }

  return (
    <div className="OnboardStart">
      <div className="OnboardStart__title">Welcome</div>
      <div className="OnboardStart__subtitle">Just a few questions and you’ll be ready to go!</div>
      <Button bsStyle="success" onClick={handleClick}>Start</Button>
    </div>
  )
}

export default OnboardStart
